var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sku-component"},_vm._l((_vm.specList),function(item,index){return _c('div',{key:index,staticClass:"sku-item"},[_c('p',[_vm._v(_vm._s(item.title)+"：")]),_c('div',{staticClass:"sku-box-area"},[_vm._l((item.list),function(item2){return [_c('div',{key:item2.id,class:{
                        'sku-box': true,
                        'sku-text': true,
                        'active': _vm.isActive(item2),
                        'disabled': !_vm.isOption(item2),
                    },on:{"click":function($event){_vm.handleClick(_vm.isOption(item2), item2, index)}}},[_vm._v(" "+_vm._s(item2.value)+" ")])]})],2)])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }